export const WHATSAPP_HREF = "https://wa.me/393520463627";

export const waLink = (text) => `${WHATSAPP_HREF}?text=${encodeURIComponent(text)}`;

export const TEAM = [
  { name: "Federico", role: "Regia e riprese" },
  { name: "Mattia", role: "Fotografia" },
  { name: "Emanuele", role: "Marketing · Presentatore" },
  { name: "Ettore", role: "Presentatore" },
];
